module.exports = __webpack_public_path__ + "static/media/sales-channels-icon.4549768e.svg";